import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form, Row, Col, Alert, Spinner } from 'react-bootstrap';
import { adminInstance } from '../../services/axiosInstance';
import Loader from '../shared/Loader';

const AppLogin = () => {
  const { register, handleSubmit, formState: { errors } } = useForm({ mode: "all" });
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [email, setEmail] = useState('');

  const onSubmit = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const obj = { UserName: userName, Password: password };
      const response = await adminInstance.post('Login', obj);
      const data = decodeJWT(response.data);
        debugger;
      sessionStorage.setItem('loginToken', response.data);
      sessionStorage.setItem('role', data.role);
      sessionStorage.setItem('userrole', data.UserRole);
      sessionStorage.setItem('username', userName);
      setIsLoading(false);
      navigate('/');
    } catch (err) {
      setIsLoading(false);
      setError("Invalid login credentials!");
    }
  };

  const forgetPassword = async () => {
    try {
        if(!email || email.length === 0 ){
            alert("Please enter email address and try again");
            return;
        }

      setIsLoading(true);
      setError(null);
      const obj = { Email: email };
      const response = await adminInstance.post('ForgotPassword', obj);
      alert(`Reset details sent successfully!`);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setError("Invalid Username !");
    }
  };

  const decodeJWT = (token) => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) =>
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join(''));
    return JSON.parse(jsonPayload);
  };

  return (
    <>
      <Loader loading={isLoading} message="Logging in..." height="300px" />
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: '100vh',
          backgroundImage: `url(${require('../../assets/images/sa-bg.png')})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          padding: '20px'
        }}
      >
        <div className="bg-white p-4 rounded shadow" style={{ width: '100%', maxWidth: '400px' }}>
          
          {/* Logo */}
          <div className="text-center mb-3">
            <img src={require('../../assets/images/logo-dark.png')} alt="Company Logo" style={{ height: '60px' }} />
          </div>

          <h5 className="text-center mb-4">Product Identification System | Login</h5>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label>Username</Form.Label>
              <Form.Control
              
                type="text"
                placeholder="Enter username"
                {...register("userName", { required: true })}
                onChange={(e) => setUserName(e.target.value)}
              />
              {errors.userName && <small className="text-danger">Username is required</small>}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                {...register("password", { required: true })}
                onChange={(e) => setPassword(e.target.value)}
              />
              {errors.password && <small className="text-danger">Password is required</small>}
            </Form.Group>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <div />
              <Button variant="link" onClick={() => { setEmail(null); setShowModal(true)}} className="p-0">Forgot Password?</Button>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            <Button type="submit" variant="primary" className="w-100">
              {isLoading ? <Spinner animation="border" size="sm" /> : 'Login'}
            </Button>
          </Form>
        </div>
      </div>

      {/* Forgot Password Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Forgot Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Enter your email</Form.Label>
              <Form.Control
                type="email"
                placeholder="example@domain.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Cancel</Button>
          <Button variant="primary" onClick={() => {
            // implement your forgot password API call
            forgetPassword();            
            setShowModal(false);
          }}>
            Send Reset Link
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AppLogin;
